var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleIconAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.428571,
    y: 47.5714,
    width: 47.1429,
    height: 47.1429,
    rx: 23.5714,
    transform: "rotate(-90 0.428571 47.5714)",
    stroke: "#474747",
    strokeWidth: 0.857143
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.001 30V18",
    stroke: "#474747",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.001 24L24.001 18L30.001 24",
    stroke: "#474747",
    strokeWidth: 1.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleIconAlt);
export default __webpack_public_path__ + "static/media/circle-icon-alt.ac4654c1e57910c2c0e2ee3deac53be6.svg";
export { ForwardRef as ReactComponent };